/**
 * Author: Amr Mossad
 * Date: 15 Feb 2022
 * Copyright: MariHub Development Team
 * Description: The Module For PrimeNg
 */
import {NgModule} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import {TableModule} from 'primeng/table';
import {InputTextModule} from 'primeng/inputtext';
import {ScrollTopModule} from 'primeng/scrolltop';
import {SelectButtonModule} from 'primeng/selectbutton';
import {PanelModule} from 'primeng/panel';
import {MenuModule} from 'primeng/menu';
import {TooltipModule} from 'primeng/tooltip';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {TagModule} from 'primeng/tag';
import {ScrollPanelModule} from "primeng/scrollpanel";
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {AutoCompleteModule} from "primeng/autocomplete";
import {CarouselModule} from "primeng/carousel";
import {TreeModule} from "primeng/tree";
import {SliderModule} from "primeng/slider";
import {RatingModule} from "primeng/rating";
import {RippleModule} from "primeng/ripple";
import {SidebarModule} from "primeng/sidebar";
import {GalleriaModule} from 'primeng/galleria';
import {SkeletonModule} from 'primeng/skeleton';
import {AccordionModule} from 'primeng/accordion';
import {TreeSelectModule} from 'primeng/treeselect';
const primeNgModule = [
    ButtonModule,
    ToastModule,
    TableModule,
    InputTextModule,
    ScrollTopModule,
    SelectButtonModule,
    PanelModule,
    MenuModule,
    TooltipModule,
    OverlayPanelModule,
    TagModule,
    ScrollPanelModule,
    InputTextModule,
    BreadcrumbModule,
    AutoCompleteModule,
    CarouselModule,
    TreeModule,
    SliderModule,
    RatingModule,
    RippleModule,
    SidebarModule,
    GalleriaModule,
    SkeletonModule,
    AccordionModule,
    TreeSelectModule
];

@NgModule({
    declarations: [],
    imports: [
        primeNgModule
    ],
    exports: [
        primeNgModule
    ]
})
export class PrimeNgModule {
}
